import { app } from '../../../../../app';
import { Controller } from './manage-shared-authenticator.controller';

app.component('companySharingCenterSharedAuthenticatorsManage', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./manage-shared-authenticator.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/manage/manage-shared-authenticator.component.js